import React from "react";
import { Row, Button } from "antd";
import type { ColumnsType } from "antd/es/table";
import Icon from "@ant-design/icons";
import Icons from 'assets/icons';


const dataServiceTable: ColumnsType = [
];


export {dataServiceTable}